import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { memo } from 'react';
import Logo from '../Logo';

const useStyles = makeStyles({
  Container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100vh',
    position: 'fixed',
    top: 0,
    zIndex: 2,
    backgroundColor: '#fff'
  },

  Box: {
    width: '300px',
    height: '200px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column'
  },

  LoaderLine: {
    position: 'relative',
    display: 'block',
    width: '100%',
    overflow: 'hidden',
    height: '4px',
    backgroundColor: 'rgba(13, 39, 113, 0.25)',

    '& > div': {
      position: 'relative',
      height: '100%',
      backgroundColor: 'inherit',

      '&::before': {
        content: '""',
        position: 'absolute',
        backgroundColor: 'inherit',
        top: 0,
        left: 0,
        bottom: 0,
        width: '100%',
        animation: `$LoaderIndeterminateAnimation 1.5s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite`
      }
    }
  },
  '@keyframes LoaderIndeterminateAnimation': {
    '0%': {
      transform: 'translateX(-100%)',
      backgroundColor: '#0d2772'
    },
    '100%': {
      transform: 'translateX(100%)',
      backgroundColor: '#0d2772'
    }
  }
});

export const LoadingPage = () => {
  const classes = useStyles();
  return (
    <div className={classes.Container}>
      <div className={classes.Box}>
        <Logo />
        <div className={classes.LoaderLine}>
          <div />
        </div>
      </div>
    </div>
  );
};

export default memo(LoadingPage);
